import { gql, useQuery } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface TopologyTranslation {
  language_code: string
  name?: string
}

export interface TopologyCity {
  id: GQL_ID
  name: string
  region_id: GQL_ID
  defaultGeoPoint?: {
    latitude?: number
    longitude?: number
    geo_lat?: number
    geo_lon?: number
  }
  i18n?: TopologyTranslation[]
}

export interface TopologyRegion {
  id: GQL_ID
  name: string
  country_id: GQL_ID
  cities: TopologyCity[]
  i18n?: TopologyTranslation[]
}

export interface TopologyCountry {
  id: GQL_ID
  name: string
  ISO2: string
  ISO3: string
  web_domain?: string
  iso_numeric?: number
  phone_code?: number
  currency_name?: string
  currency_symbol?: string
  language_codes?: string
  regions: TopologyRegion[]
}

export interface TopologyData {
  topology: {
    countries: TopologyCountry[]
  }
}

export const GQL_QUERY_TOPOLOGY = gql`
  query topology {
    topology {
      countries {
        id
        name
        ISO2
        ISO3
        web_domain
        iso_numeric
        phone_code
        currency_name
        currency_symbol
        language_codes
        regions {
          id
          name
          country_id
          i18n {
            language_code
            name
          }
          cities {
            id
            name
            region_id
            defaultGeoPoint {
              latitude
              longitude
              geo_lat
              geo_lon
            }
            i18n {
              language_code
              name
            }
          }
        }
      }
    }
  }
`

export const useFetchTopology = () => useQuery<TopologyData>(GQL_QUERY_TOPOLOGY)
